import React from 'react'

import { Flex, FlexCenter } from '../Flex'
import { InputModal } from '../InputModal'
import { Close } from '../Icon'
import { H4 } from '../Heading'
import './whoop-investment-confirmation-modal.scss'

type Props = {
  active: boolean
  handleOnClose: () => void
}

const WhoopInvestmentConfirmationModal = ({ active, handleOnClose }: Props) => {
  if (!active) return null

  return (
    <InputModal onBackdropClick={handleOnClose}>
      <FlexCenter variant='column' classes={['whoop-investment-confirmation-modal-container']}>
        <div
          className='whoop-investment-confirmation-card p-24'
          data-testid='whoop-investment-confirmation-modal'
        >
          <Flex variant='space-between' classes={['mb-16']}>
            <H4 text='Order received' />
            <Close type='default-light' onClick={handleOnClose} />
          </Flex>
          <p className='basic'>
            We have received your investment order. Your allotment confirmation will be issued
            within 24 hours.
          </p>
        </div>
      </FlexCenter>
    </InputModal>
  )
}

export { WhoopInvestmentConfirmationModal }
